export type TNativeDynamicsCompressorNode = DynamicsCompressorNode;
